module.exports = __webpack_public_path__ + "img/composer-emoji.6e6a3e61.svg";